import Box from "@mui/material/Box";

import { Typography, useTheme } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import LinkTab, { samePageLinkNavigation } from "./components/tab";
import TabPanel from "./components/tabPanel";
import { CategoryListItemType } from "./types";

const DesktopProductFinder = ({
	tabList,
}: {
	tabList: CategoryListItemType[];
}) => {
	const [value, setValue] = useState(0);
	const [resetFilters, setResetFilters] = useState(false);
	const [canResetFilters, setCanResetFilters] = useState(false);
	const theme = useTheme();

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		// event.type can be equal to focus with selectionFollowsFocus.
		if (
			event.type !== "click" ||
			(event.type === "click" &&
				samePageLinkNavigation(
					event as React.MouseEvent<HTMLDivElement, MouseEvent>
				))
		) {
			setValue(newValue);
		}
	};

	return (
		<div className="w-full pt-14 mb-5">
			<div className="flex gap-3">
				<Typography
					variant="h4"
					sx={{
						lineHeight: "23px",
						fontSize: "20px",
						color: theme.palette.primary.main,
						fontWeight: "700",
					}}
				>
					Defense and Aerospace Product Explorer
				</Typography>
				{canResetFilters && (
					<button
						className="text-sm underline hover:no-underline hover:text-teradyne-blue focus:text-teradyne-blue"
						onClick={() => setResetFilters(true)}
					>
						Reset Filters
					</button>
				)}
			</div>
			<div>
				<Typography
					variant="body1"
					sx={{
						lineHeight: "24px",
						fontSize: "14px",
						fontWeight: "400",
						marginTop: "20px",
					}}
				>
					Select Product Group
				</Typography>
			</div>
			<Box>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="nav tabs scrollable"
					indicatorColor="primary"
					role="navigation"
					variant="scrollable"
					scrollButtons="auto"
					TabIndicatorProps={{
						style: {
							height: 3,
						},
					}}
					sx={{
						borderBottom: "1px solid #aaa",
						"& .MuiTabs-flexContainer": {
							gap: "40px",
						},
					}}
				>
					{tabList.map((tab, index) => (
						<LinkTab key={index} label={tab.label} />
					))}
				</Tabs>
			</Box>
			{tabList.map((tab, index) => (
				<TabPanel
					key={index}
					value={value}
					tab={tab}
					index={index}
					resetFilters={resetFilters}
					setResetFilters={setResetFilters}
					setCanResetFilters={setCanResetFilters}
				/>
			))}
		</div>
	);
};

export default DesktopProductFinder;
